<template>
  <base-popover
    v-slot="{ toggle, close, opened }"
    data-test-id="vf-dropdown"
    interactive
    :offset="-1"
    placement="bottom-start"
  >
    <base-button
      :aria-controls="id"
      :aria-expanded="opened"
      aria-haspopup="true"
      class="relative h-10 flex items-center b b-grey-10 space-x-1"
      :class="[
        brandClasses.button,
        opened ? ['z-2', brandClasses.buttonOpened, classButtonOpened] : brandClasses.buttonClosed,
        classButton,
      ]"
      :style="styleButton"
      @click="toggle"
      @keydown.esc="close"
    >
      <slot name="label">
        <span v-if="label" class="pointer-events-none text-sm">{{ label }}</span>
      </slot>
      <vf-icon class="pointer-events-none" dir="down" name="chevron" size="md" />
    </base-button>
    <base-popover-content
      :id
      class="z-1 overflow-auto rounded-xs rounded-tl-none bg-white px-4 pb-6 pt-5 shadow-lg ring-grey-70 ring-inset transition scrollbar-sm"
      :class="[brandClasses.popoverContent, classContent]"
      data-test-id="vf-dropdown-content"
      enter-active-class="transform ease-out"
      enter-from-class="op-0"
      enter-to-class="translate-y-0"
      leave-active-class="transform ease-in"
      leave-from-class="translate-y-0"
      leave-to-class="op-0"
      role="listbox"
      style="max-width: 46.5rem; max-height: 26rem"
      :style="styleContent"
      @keydown.esc="close"
    >
      <!-- @slot Slot for dropdown content -->
      <slot />
    </base-popover-content>
  </base-popover>
</template>

<script lang="ts" setup>
import type { CSSClass } from '#types/common'

defineProps<{
  /**
   * Label for dropdown trigger
   */
  label?: string
  /**
   * Classes to be applied to content container.
   */
  classContent?: CSSClass
  /**
   * Styles to apply to button.
   */
  classButton?: CSSClass
  /**
   * Styles to apply to button when its expanded.
   */
  classButtonOpened?: CSSClass
  /**
   * Styles to apply to content container.
   */
  styleContent?: string | object
  /**
   * Styles to apply to button.
   */
  styleButton?: string | object
}>()

const id = useId()
const { brandClasses } = useAppConfig().components.vf.dropdown
</script>
